import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import { User } from 'services/auth/auth.types';
import { AgendaEvent, CreateAgendaEventPayload, GetAgendaEventsPayload, UpdateAgendaEventPayload } from './agenda.types';

const agendaApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        // AppBundle Requests
        // getAllUsers: build.mutation<ApiResponse<Array<User>>, ApiRequest<any>>({
        //     query: () => ({
        //         url: `/app/users`,
        //         method: 'GET'
        //     }),
        //     transformResponse: (response: ApiResponse<Array<User>>) => ({
        //         code: response.code,
        //         data: response.data,
        //         status: response.status
        //     })
        // }),
        // UserBundle Requests
        getUserAgenda: build.mutation<ApiResponse<Array<AgendaEvent>>, ApiRequest<undefined>>({
            query: () => ({
                url: `/user/agenda/events`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Array<AgendaEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getAgendaEvents: build.mutation<ApiResponse<Array<AgendaEvent>>, GetAgendaEventsPayload>({
            query: ({ started_at, ended_at, users }: GetAgendaEventsPayload) => ({
                url: `/app/agenda/events`,
                method: 'GET',
                params: {
                    started_at,
                    ended_at,
                    users
                }
            }),
            transformResponse: (response: ApiResponse<Array<AgendaEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createAgendaEvent: build.mutation<ApiResponse<AgendaEvent>, CreateAgendaEventPayload>({
            query: (payload) => ({
                url: `/app/agenda/events`,
                method: 'POST',
                body: payload
            }),
            transformResponse: (response: ApiResponse<AgendaEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateAgendaEvent: build.mutation<ApiResponse<AgendaEvent>, UpdateAgendaEventPayload>({
            query: (payload) => ({
                url: `/app/agenda/events/${payload.id}`,
                method: 'PUT',
                body: payload
            }),
            transformResponse: (response: ApiResponse<AgendaEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateAgendaEventStatus: build.mutation<ApiResponse<AgendaEvent>, { id: string, status: string }>({
            query: ({ id, status }) => ({
                url: `/app/agenda/events/${id}/status`,
                method: 'PUT',
                body: { status }
            }),
            transformResponse: (response: ApiResponse<AgendaEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deleteAgendaEvent: build.mutation<ApiResponse<AgendaEvent>, { id: string }>({
            query: ({ id }) => ({
                url: `/app/agenda/events/${id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: ApiResponse<AgendaEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetUserAgendaMutation,
    useGetAgendaEventsMutation,
    useCreateAgendaEventMutation,
    useUpdateAgendaEventMutation,
    useUpdateAgendaEventStatusMutation,
    useDeleteAgendaEventMutation
} = agendaApi;
